export const roleLabel = (role) => ({
  owner: "Owner",
  partner: "Partner / Co-owner",
  accountant: "Accountant / CPA",
  employee: "Employee",
}[role] || "Team member");

export const isFullBusinessRole = (business) => {
  const role = business?.access_role || business?.permissions?.access_role || "owner";
  return role === "owner" || role === "partner";
};

export const defaultBusinessTab = (business, toolKeys = []) => {
  const role = business?.access_role || "owner";
  if (role === "employee") return toolKeys.includes("invoices") ? "invoices" : (toolKeys[0] || "invoices");
  if (role === "accountant") return toolKeys.includes("accounting") ? "accounting" : (toolKeys[0] || "accounting");
  return "fundamentals";
};

export const filterBusinessTools = (allTools, business) => {
  const permissions = business?.permissions || {};
  return allTools.filter((key) => {
    if (["books"].includes(key)) return permissions.can_view_books !== false;
    if (["accounting"].includes(key)) return permissions.can_view_accounting !== false;
    if (["ar"].includes(key)) return permissions.can_view_receivables !== false;
    if (["ap"].includes(key)) return permissions.can_view_payables !== false;
    if (["forecast"].includes(key)) return permissions.can_view_forecast !== false;
    if (["taxes"].includes(key)) return permissions.can_view_taxes !== false;
    if (["invoices", "memberships", "estimates"].includes(key)) return permissions.can_manage_invoices !== false;
    if (["receipts"].includes(key)) return permissions.can_manage_receipts !== false;
    if (["mileage"].includes(key)) return permissions.can_manage_mileage !== false;
    if (["jobs"].includes(key)) return permissions.can_view_jobs !== false;
    if (["vault"].includes(key)) return permissions.can_view_vault !== false;
    if (["portal"].includes(key)) return permissions.can_view_portal !== false;
    if (["diagnose"].includes(key)) return permissions.can_view_diagnose !== false;
    if (["contractor", "supplies", "scheduler", "production", "square_sync", "onboarding", "wellness_ops"].includes(key)) return isFullBusinessRole(business);
    return true;
  });
};